<div class="p-auth -pattern">
  <div class="p-auth__header">
    <img class="p-auth__logo" [src]="configurationService.data().brand.icon" width="233" height="92" alt="" />
    <div class="p-auth__subtitle">World leading affiliate network</div>
  </div>
  <div class="p-auth__inner">
    <div class="p-auth__content">
      <router-outlet></router-outlet>
    </div>
  </div>
  <div class="p-auth__footer">
    <gtd-footer></gtd-footer>
  </div>
</div>
